import brandMark from '../assets/logo-export-dark.svg';
import './Hero.scss';

function Hero() {
  return (
    <section id="top" className="hero hero-gradient">
      <div className="container hero__layout">
        <div className="hero__center">
          <img className="hero__logo" src={brandMark} alt="Cipher Works logo" />
          <h1>
            Too complex for <span className="hero__muted-term">DIY</span>, too small for big firm
            budgets? Just right for Cipher Works.
          </h1>
          <p>
            Cipher Works builds custom fixtures, low noise cable assemblies, and precise short run
            tooling when off the shelf parts or big firm workflows aren&apos;t the right fit.
          </p>
          <div className="hero__cta-group">
            <a className="cta-button" href="#contact">
              Start Your Project
            </a>
            <a className="hero__secondary" href="#case-studies">
              See Recent Work
            </a>
          </div>
          <ul className="hero__highlights">
            <li>Reverse engineered parts ready in days</li>
            <li>Fixtures, jigs, and shielded cable builds</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Hero;
